function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 7.14208C12.5 6.6989 12.4602 6.27276 12.3864 5.86367H6.49999V8.28129H9.86363C9.71874 9.06254 9.2784 9.72447 8.61647 10.1677V11.7358H10.6364C11.8182 10.6478 12.5 9.04549 12.5 7.14208Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.49999 13.25C8.1875 13.25 9.60227 12.6904 10.6364 11.7358L8.61647 10.1676C8.05681 10.5426 7.3409 10.7642 6.49999 10.7642C4.87215 10.7642 3.49431 9.66478 3.00283 8.18751H0.914757V9.80683C1.94317 11.8494 4.05681 13.25 6.49999 13.25Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.00282 8.18755C2.87782 7.81255 2.8068 7.41198 2.8068 7.00004C2.8068 6.58811 2.87782 6.18754 3.00282 5.81254V4.19322H0.914751C0.491455 5.03697 0.249977 5.99152 0.249977 7.00004C0.249977 8.00857 0.491455 8.96312 0.914751 9.80687L3.00282 8.18755Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.49999 3.23583C7.41761 3.23583 8.24147 3.55117 8.8892 4.17049L10.6818 2.37787C9.59943 1.36935 8.18465 0.750031 6.49999 0.750031C4.05681 0.750031 1.94317 2.1506 0.914757 4.19322L3.00283 5.81254C3.49431 4.33526 4.87215 3.23583 6.49999 3.23583Z",
  fill: "#EA4335"
});

function SvgGoogleLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoSmall);
export default __webpack_public_path__ + "static/media/google-logo-small.5e73752f.svg";
export { ForwardRef as ReactComponent };